<template>
  <div class="home-wrap">
    <!-- 一键筛选按钮 -->
    <div class="filter-tab">
      <span class="tab-item" :class="{ active: filterType === 'all' }" @click="filterType = 'all'">全部短文</span>
      <span class="tab-item" :class="{ active: filterType === 'collect' }" @click="filterType = 'collect'">我的收藏</span>
    </div>

    <div class="card-scroll">
      <div class="card-list">
        <div class="article-card" v-for="item in showArticleList" :key="item.ID"
          @click="$router.push('/article/' + item.ID)">
          <!-- 左上角星级标签 + 阅读数，0不显示阅读数 -->
          <div class="star-tag" v-html="getStarSvg(item.star)">
          </div>
          <!-- 右上角收藏按钮 -->
          <div class="collect-icon" @click.stop="toggleCollect(item)">
            <span v-if="Number(item.readUserCount) > 0" class="read-count-text">{{ item.readUserCount }}</span>
            <svg v-if="!isCollect(item.ID)" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#94a3b8"
              stroke-width="2">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            </svg>
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="#6366f1">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>

          <div class="card-row">
            <div class="card-img" v-if="item.imageName">
              <img :src="`${item.imageName}`" alt="插图" />
            </div>
            <div class="card-img empty-img" v-else>
              <span>插图</span>
            </div>
            <div class="card-title-box">
              <h3>{{ item.title }}</h3>
            </div>
          </div>
        </div>
        <div v-if="loading" class="empty-tip">加载中...</div>
        <div v-if="!loading && showArticleList.length === 0" class="empty-tip">{{
          filterType === 'collect' ? '暂无收藏短文' : '暂无短文数据，请前往后台添加' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { readerFetch } from '@/utils/request'
export default {
  name: 'ReadHome',
  data() {
    return {
      articleList: [],
      loading: false,
      collectIds: [],
      filterType: "all",
      // 从登录缓存读取当前真实用户ID，不再写死1
      currentReaderId: Number(localStorage.getItem("readerId")) || 0
    }
  },
  computed: {
    // 核心：筛选后的最终列表
    showArticleList() {
      let arr;
      if (this.filterType === 'collect') {
        arr = this.articleList.filter(item => this.collectIds.includes(Number(item.ID)))
      } else {
        arr = this.articleList
      }
      // 追加 status="1" 过滤；status不等于"1"直接剔除
      return arr.filter(item => item.status === "1")
    },
  },
  mounted() {
    // 校验登录状态，无用户ID跳转登录
    if (!this.currentReaderId) {
      this.$router.push("/login")
      return
    }
    this.fetchCollectStatus()
    this.fetchArticleList()
  },
  methods: {
    // 获取当前登录用户收藏ID列表（只用当前用户id，不再请求id=1）
    async fetchCollectStatus() {
      try {
        const res = await readerFetch(`/info?reader_id=${this.currentReaderId}`)
        this.collectIds = res.data.collectArticleIds || []
      } catch (e) {
        this.collectIds = []
      }
    },
    // 判断是否收藏
    isCollect(id) {
      return this.collectIds.includes(Number(id))
    },
    // 切换收藏/取消收藏，传当前真实用户ID
    async toggleCollect(item) {
      const aid = Number(item.ID)
      try {
        if (this.isCollect(aid)) {
          await readerFetch("/uncollect", {
            method: "POST",
            body: { userId: this.currentReaderId, articleId: aid }
          })
          this.collectIds = this.collectIds.filter(v => v !== aid)
        } else {
          await readerFetch("/collect", {
            method: "POST",
            body: { userId: this.currentReaderId, articleId: aid }
          })
          this.collectIds.push(aid)
        }
      } catch (err) {
        alert("操作失败")
      }
    },
    async fetchArticleList() {
      this.loading = true
      try {
        const res = await readerFetch('/article/list')
        this.articleList = res.data || []
      } catch (err) {
        console.error("短文列表加载失败", err)
      } finally {
        this.loading = false
      }
    },
    getStarSvg(starNum) {
      const fullSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="#ff5555"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`
      const emptySvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="#fefdff"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`
      let html = ''
      for (let i = 0; i < 5; i++) {
        html += i < starNum ? fullSvg : emptySvg
      }
      return html
    }
  }
}
</script>

<style scoped>
.home-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 筛选标签栏 */
.filter-tab {
  background-color: #63667550;
  display: flex;
  gap: 12px;
  padding: 1px 24px;
}

.tab-item {
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 15px;
  cursor: pointer;
  color: #a5b5c5;
}

.tab-item.active {
  background: #6366f1;
  color: #fff;
}

.card-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 30px;
}

.card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.article-card {
  position: relative;
  background: #7fbfff75;
  padding: 20px 5px 5px 5px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.56);
  cursor: pointer;
  transition: 0.2s;
}

.article-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.12);
}

.star-tag {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 12px;
  color: #6366f1;
  background: #f0f4ff55;
  padding: 3px 8px;
  border-radius: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 4px;
}

.read-count-text {
  font-size: 15px;
  color: #d4d5ff;
  white-space: nowrap;
}

.collect-icon {
  position: absolute;
  top: 5px;
  right: 7px;
  z-index: 2;
}

.card-row {
  display: flex;
  align-items: top;
  gap: 6px;
  margin-top: 12px;
}

.card-img {
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f7fa;
}

.empty-img {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
}

.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title-box h3 {
  margin: 0;
  color: #1e293b;
  font-size: 17px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-tip {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 0;
  color: #485159;
}

@media screen and (max-aspect-ratio:1/1) {
  .card-scroll {
    padding: 16px;
  }

  .card-list {
    grid-template-columns: 1fr;
  }

  .card-img {
    width: 80px;
    height: 80px;
  }
}
</style>